// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.medalhas-grid {
  display: grid;
  /* grid-template-columns: repeat(3, 1fr); 3 colunas fixas */
  grid-template-columns: repeat(
    auto-fill,
    [col-start] minmax(200px, 1fr) [col-end]
  );
  gap: 35px;
  justify-items: center;
  width: 100%;
  margin-right: 10px;
  overflow-x: hidden;
  transform: translateX(-10px);
}

.medalha-item {
  background: var(--cor-roxoClaro);
  border-radius: 16px;
  width: 190px;
  height: 260px;
  padding: 16px;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.medalha-item:hover {
  transform: scale(1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.medalha-item img {
  width: 180px;
  height: 200%;
  margin-top: 1px;
  margin-bottom: 10px;
}

.medalha-item p {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: var(--cor-preto);
  margin-bottom: 8px;
}

.medalha-item.bloqueada img {
  opacity: 0.5;
}

@keyframes fadeOut {
  to {
    opacity: 0;
    transform: translateY(-5px);
  }
}

/* Responsivo */
@media (max-width: 768px) {
  .medalhas-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  .medalha-item {
    width: 160px;
    height: 230px;
  }

  .medalha-item img {
    width: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Componets/Medalha.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D;;;GAGC;EACD,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,eAAe;AACf;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".medalhas-grid {\n  display: grid;\n  /* grid-template-columns: repeat(3, 1fr); 3 colunas fixas */\n  grid-template-columns: repeat(\n    auto-fill,\n    [col-start] minmax(200px, 1fr) [col-end]\n  );\n  gap: 35px;\n  justify-items: center;\n  width: 100%;\n  margin-right: 10px;\n  overflow-x: hidden;\n  transform: translateX(-10px);\n}\n\n.medalha-item {\n  background: var(--cor-roxoClaro);\n  border-radius: 16px;\n  width: 190px;\n  height: 260px;\n  padding: 16px;\n  text-align: center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.medalha-item:hover {\n  transform: scale(1);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.medalha-item img {\n  width: 180px;\n  height: 200%;\n  margin-top: 1px;\n  margin-bottom: 10px;\n}\n\n.medalha-item p {\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--cor-preto);\n  margin-bottom: 8px;\n}\n\n.medalha-item.bloqueada img {\n  opacity: 0.5;\n}\n\n@keyframes fadeOut {\n  to {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n  .medalhas-grid {\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  }\n\n  .medalha-item {\n    width: 160px;\n    height: 230px;\n  }\n\n  .medalha-item img {\n    width: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
